import axios from 'axios';
import config from '../config';
import { FormType } from '../types/FormType';
import DataDogInstance from '../utils/monitoring';
import { RateLimiter } from '../utils/rateLimit';

const gatewayUrl = config.APIGW_URL;

export async function SubmitForm(data: FormType): Promise<void> {
  try {
    await RateLimiter.getInstance().checkRateLimit('form');
    const response = await axios.post(`${gatewayUrl}/form/submit`, data, {
      headers: {
        'X-CG-AppIdentifier': 'coign-web',
      },
    });

    return response.data;
  } catch (error) {
    const isNetworkError =
      axios.isAxiosError(error) && error.message === 'Network Error';

    if (!isNetworkError) {
      DataDogInstance.getInstance().logError(
        'Failed to submit form',
        { data, gatewayUrl },
        error as Error
      );
    }
    throw error;
  }
}
